// extracted by mini-css-extract-plugin
export var bubble = "_34-0";
export var container = "_34-3";
export var contrastBorder = "_34-4";
export var greyOut = "_34-2";
export var initialsWrapper = "_34-1";
export var large = "_34-9";
export var medium = "_34-8";
export var mediumSmall = "_34-7";
export var mediumSmallMedium = "_34-c";
export var micro = "_34-5";
export var small = "_34-6";
export var tiny = "_34-b";
export var xTiny = "_34-a";